import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { ThreadRepositoryState} from './types';

export const actions: ActionTree<ThreadRepositoryState, RootState> = {

};
